
import {actionTypes} from '../constants/actionTypes';

const {sslCertificates} = actionTypes;

const initialState = {
    sslCertificates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case sslCertificates.GET_SSLCERTIFICATES_SUCCESS:
      return {
        ...state,
        sslCertificates: action.payload
      };
    default:
      return state;
  }
}